import { useChangeFilterValue, useFilterValue } from '@btime/react-contexts'
import { useTranslation } from 'react-i18next'
import React from 'react'

import FilterLink from '../../../../components/filter/FilterLink'
import FilterListItem from '../../../../components/list/FilterListItem'
import FilterSideModal from '../../../../components/filter/FilterSideModal'

const ORIGINS = ['non_compliance', 'automation', 'manual']

const AvailabilityStatusOriginFilter = () => {
  const { t } = useTranslation('availability')
  const [open, setOpen] = React.useState(false)

  const handleChange = useChangeFilterValue()
  const filter = useFilterValue('availabilityStatusOrigin')

  const setOrigin = value => handleChange('availabilityStatusOrigin', filter === value ? undefined : value)

  return (
    <>
      <FilterLink
        icon="RiHistoryLine"
        label={t('filterByOrigin')}
        value={filter && t(`origin.${filter}`)}
        onClick={() => setOpen(true)}
      />

      <FilterSideModal
        open={open}
        onClose={() => setOpen(false)}
        label={t('filterByOrigin')}
        renderOptions={() =>
          ORIGINS.map(origin => (
            <FilterListItem
              key={origin}
              onClick={() => setOrigin(origin)}
              label={t(`origin.${origin}`)}
              isSelected={filter === origin}
            />
          ))
        }
      />
    </>
  )
}

export default AvailabilityStatusOriginFilter
